<template>
    <hot-toast></hot-toast>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'notification-manager',
    computed: {
      ...mapState('notification', ['notifications'])
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .notification-area {
    margin: auto;
    padding: 10px 20px 30px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    pointer-events: none;
    position: fixed;
    top: 48px;
    right: 0;
    left: 0;
    z-index: 1000000;
  }

  .notification-item {
    @include fade-transition;
    width: 250px;
    height: 70px;
    margin-bottom: 20px;
    display: flex;
    position: relative;
    pointer-events: auto;
    border-radius: 3px;
    box-shadow: 0 3px 5px -1px rgba(#000, .2),
                0 6px 10px rgba(#000, .14),
                0 1px 18px rgba(#000, .12);
    font-size: 13px;
    font-weight: bold;

    &.left {
      align-self: flex-start;
    }

    &.success {
      color: $color-green;

      .notification-content {
        background: $color-green;
      }
    }

    &.error {
      color: $color-red;

      .notification-content {
        background: $color-red;
      }
    }

    &.info {
      color: $color-gold;

      .notification-content {
        background: $color-gold;
      }
    }
  }

  .notification-content {
    padding: 5px 12px;
    display: flex;
    align-items: center;
    flex: 1;
    z-index: 20;
    border-radius: 3px;
    background-color: $color-lighter-gray;
    color: #fff;
  }

  .notification-close {
    @include clear-button;
    width: 8px;
    height: 8px;
    position: absolute;
    top: 8px;
    right: 8px;
    color: #fff;
    font-size: 22px;
    font-weight: bold;
    line-height: 1em;
    vertical-align: top;
    text-align: center;

    svg {
      path {
        fill: #fff;
      }
    }
  }

  .notification-text {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .notification-mart {
    width: 42px;
    height: 50px;
    margin-right: 10px;
  }
</style>
